import dayjs from "dayjs"
import { criteoPush } from "~/utils/functions/crto"
import { rtbPush } from "~/utils/functions/rtb"
import { sortCategories } from "~/utils/functions/product"
import { karteCustomEventPush, createProduct } from "~/utils/functions/karte"

export const useSocial = () => {
  const route = useRoute()
  const config = useRuntimeConfig()
  const gtag = useGtag()
  const { FBPixelEventPush, FBCApiEventPush } = useFB()

  const marketingTagsEvent = (
    pagePartsRef: {
      product_id?: string
      product?: {
        document_id: string
        name: string
        product_categories?: {
          document_id: string
          parent_category?: { name?: string; slug?: string }
          name?: string
          slug?: string
        }[]
        product_category_ids?: (string | undefined)[]
        skus?: { document_id: string; price: number }[]
      }
    }[],
  ) => {
    if (!process.client || config.public.APP_ENV !== "production" || pagePartsRef.length < 1) {
      return
    }
    const karteProducts = []
    const gaProducts = []
    let totalValue = 0
    for (const pageParts of pagePartsRef) {
      if (pageParts.product_id) {
        const productId = pageParts.product?.document_id || ""
        const unixTime = dayjs().unix()
        const viewContentId = productId + unixTime
        const productTitle = pageParts.product?.name || ""
        const userAgent = window.navigator.userAgent || ""
        const url = window.location.href
        const price = pageParts.product?.skus?.[0]?.price ?? 0
        totalValue += price
        FBPixelEventPush(viewContentId, "product", "ViewContent", productTitle, productTitle)
        FBCApiEventPush(viewContentId, "ViewContent", productTitle, userAgent, url)
        criteoPush("productView", { id: productId, email: "" })
        if (pageParts?.product?.skus && pageParts.product.skus.length > 0)
          rtbPush(`_offer_${pageParts.product.skus[0].document_id}`)
      }

      if (pageParts.product) {
        const productCategories = sortCategories(
          pageParts.product?.product_categories ?? [],
          pageParts.product?.product_category_ids ?? [],
        )
        karteProducts.push(
          createProduct(pageParts.product, productCategories, {
            priceKey: "item_price",
            category3Key: "item_xl_category",
            category2Key: "item_m_category",
            categoryKey: "item_l_category",
          }),
        )
        gaProducts.push(
          createProduct(pageParts.product, productCategories, {
            priceKey: "price",
            category3Key: "item_category3",
            category2Key: "item_category2",
            categoryKey: "item_category",
          }),
        )
      }
    }
    // karte
    karteCustomEventPush("view_item", {
      items: karteProducts,
      url: route.fullPath,
      keyword: route.params.keyword || "",
    })
    // GA
    gtag("event", "view_item", {
      currency: "JPY",
      value: totalValue,
      items: gaProducts,
    })
  }

  return {
    marketingTagsEvent,
  }
}
